import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@vnetwork/ui/primitives';
import { ReceivedTab, AwaitingTab } from './components/my-ratings-tabs';
import { AccountBreadcrumbs } from './components/account-breadcrumbs';

/**
 * My Ratings — received ratings (with summary card) and tickets awaiting
 * the signed-in employee's rating. Real data via internal-ratings API.
 * Mirrors MyIncomesPage (gated list + stat cards).
 *
 * Tab components + RatingSummaryCard live in components/my-ratings-tabs.tsx
 * to keep each file under the 200-line guideline.
 */
export default function MyRatingsPage() {
  return (
    <Container size="full">
      <PageHeader
        breadcrumbs={<AccountBreadcrumbs current="My Ratings" />}
        title="My Ratings"
        description="Ratings you have received and tickets you need to rate"
      />
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <Tabs defaultValue="received">
          <TabsList style={{ marginBottom: 'var(--vn-space-4)' }}>
            <TabsTrigger value="received">Received</TabsTrigger>
            <TabsTrigger value="awaiting">Awaiting</TabsTrigger>
          </TabsList>
          <TabsContent value="received">
            <ReceivedTab />
          </TabsContent>
          <TabsContent value="awaiting">
            <AwaitingTab />
          </TabsContent>
        </Tabs>
      </div>
    </Container>
  );
}
